import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../components/button'
import { SelectProductModal } from '../../components/modal/app_modals/selectProductModal'
import { ProductTileContainer } from '../../components/product/productTile'
import Spinner from '../../components/spinner/Spinner'
import { removeElementAtIndex } from '../../helpers'
import { useModalControl } from '../../hooks/useModalControl'
import {
  useAddProductsToListMutation,
  useGetListProductsQuery,
  useUpdateProductsInListMutation,
} from '../../redux-toolkits/lists/list.slice'
import { Product } from '../../redux-toolkits/products/products.type'
export const ManageEssentialProducts = () => {
  const [products, setProducts] = useState<Product[]>([])

  const { id } = useParams<{ id: string }>()

  const navigate = useNavigate()

  const { setModalOpen, modal, handleModalOpen, modalOpen, handleModalClose } =
    useModalControl()

  const { data: listProducts, isFetching: fetchingList } =
    useGetListProductsQuery(id || '')

  const [updateProductsInList, { isLoading: addingToList }] =
    useUpdateProductsInListMutation()

  const [addProductsToList, { isLoading: addingNewToList }] =
    useAddProductsToListMutation()

  useEffect(() => {
    if (listProducts?.data?.products) {
      setProducts(listProducts.data.products)
    }
  }, [listProducts?.data?.products])

  return fetchingList ? (
    <Spinner fullScreen={false} />
  ) : (
    <div className="flex flex-col gap-10">
      <div className="flex flex-wrap items-center justify-end gap-4">
        <div className="flex items-center gap-4 justify-end">
          <Button
            type="button"
            onClick={() => {
              navigate('/lists/curated')
            }}
            label="Cancel"
            size="medium"
            className="!px-10"
          />

          <Button
            type="submit"
            label="Save"
            primary
            disabled={addingToList || addingNewToList}
            loading={addingToList || addingNewToList}
            size="medium"
            className="!px-10"
            onClick={() => {
              if (listProducts?.data?.products?.length === undefined) {
                addProductsToList({
                  productIds: products.map((product) => product._id),
                  listId: id ?? '',
                })
              } else {
                updateProductsInList({
                  productIds: products.map((product) => product._id),
                  listId: id ?? '',
                })
              }
            }}
          />
        </div>
      </div>

      <ProductTileContainer
        products={products}
        handleSortEnd={(products) => {
          setProducts(products)
        }}
        canDelete
        onDeleteProduct={(p, idx) => {
          const productsCopy = JSON.parse(JSON.stringify(products))
          setProducts(removeElementAtIndex(productsCopy, idx))
        }}
        sortable
        onViewProduct={(p) => {
          navigate(`/products/view/${p?._id}`)
        }}
      />

      <div className={`flex justify-center w-full`}>
        <Button
          type="button"
          onClick={() => {
            handleModalOpen('selectProductModal')
          }}
          label="Add products"
          primary
          className="!px-10"
        />
      </div>

      <SelectProductModal
        open={modal === 'selectProductModal' && modalOpen}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        selectedProducts={products}
        onSuccessCallback={(selectedProducts: Product[]) => {
          setProducts([
            ...products,
            ...selectedProducts.filter(
              (p) => !products.map((i) => i._id).includes(p._id),
            ),
          ])

          handleModalClose()
        }}
      />
    </div>
  )
}
